export default __webpack_public_path__ + "static/media/cif-co.1ed76799.svg";